<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="bg-second-migas">
  <div class="container mt-cab-fixed">
    <div class="pre-content">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a style="cursor: pointer;" (click)="navigateBack()">Cert. Valorización Final</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Detalle CVF</li>
        </ol>
      </nav>
      <div class="content-title-with-info align-items-start">
        <div class="d-flex flex-column">
            <div class="d-flex align-items-center">
              <h2 class="title-pag">Certificado de Valorización Final</h2>
              <div class="tool-help" (click)="openModalAyuda()" style="cursor: pointer;"><span>?</span></div>
            </div>
            <div class="custom-container mt-2" [ngStyle]="styleEstado" *ngIf="cvfData?.estado" [matTooltip]="getEstadoTooltip()">
              <div>
                <span style="font-size: larger; padding-top: 2px;">
                  <mat-icon class="show-icon" [ngStyle]="{'color': styleEstado.color + ' !important'}">{{'warning_amber'}}</mat-icon>
                </span>
              </div>
              <div>
                <span class="info-texto-estado" [ngStyle]="{'color': styleEstado.color + ' !important'}">
                  {{cvfData?.estado?.descripcion}}</span>
              </div>
            </div>
        </div>
        
        <div class="d-flex flex-column align-items-end" *ngIf="cvfData">
          
          <!-- Primera Fila: Año, NIMA, Fecha Fin -->
          <div class="cvf-header-info-inline">
            <div class="info-item">
              <span class="label-grey">Año de los datos:</span>
              <span class="value-bold">{{ cvfData.anno }}</span>
            </div>

            <!-- NIMA (Gestor) -->
            <ng-container *ngIf="!isCvfPoseedor()">
              <div class="info-item">
                  <span class="label-grey">NIMA Gestor:</span>
                  <span class="value-bold">{{ cvfData.gestorResiduos?.nima }}</span>
              </div>
            </ng-container>

            <!-- NIMA (Poseedor) -->
            <ng-container *ngIf="isCvfPoseedor()">
              <div class="info-item">
                  <span class="label-grey">NIMA Gestor:</span>
                  <span class="value-bold">
                    {{ isGestorRegistrado() ? cvfData.gestorResiduos?.nima : cvfData.nimaGestor }}
                  </span>
              </div>
            </ng-container>

            <div class="info-item">
              <span class="label-grey">Fecha Finalización:</span>
              <span class="value-bold">{{ this.fechaFinCvf || '' }}</span>
            </div>
          </div>

          <!-- Segunda Fila: Razón Social, Documento -->
          <div class="cvf-header-info-inline mt-1" style="display: flex; gap: 10px;">
            <!-- Razón Social (Gestor) -->
            <ng-container *ngIf="!isCvfPoseedor()">
              <div class="info-item">
                  <span class="label-grey">Razón Social Gestor:</span>
                  <span class="value-bold">{{ cvfData.gestorResiduos?.razonSocial }}</span>
              </div>
            </ng-container>

            <!-- Razón Social, Doc (Poseedor) -->
            <ng-container *ngIf="isCvfPoseedor()">
              <div class="info-item">
                  <span class="label-grey">Razón Social Gestor:<span *ngIf="isGestorNoRegistradoPendiente()" class="oblig">*</span></span>
                  <span *ngIf="isGestorDisplayVisible()" class="value-bold">{{ cvfData.gestorResiduos?.razonSocial }}</span>
                  <input *ngIf="shouldShowGestorManualInput()" type="text" class="input-manual-gestor" [(ngModel)]="cvfData.gestorResiduos.razonSocial" (ngModelChange)="onDatosGestorChange()" placeholder="Razón Social">
              </div>
              <div class="info-item">
                  <span class="label-grey">Documento Gestor:<span *ngIf="isGestorNoRegistradoPendiente()" class="oblig">*</span></span>
                  <span *ngIf="isGestorDisplayVisible()" class="value-bold">{{ cvfData.gestorResiduos?.codigoDocumento }}</span>
                  <input *ngIf="shouldShowGestorManualInput()" type="text" class="input-manual-gestor" [(ngModel)]="cvfData.gestorResiduos.codigoDocumento" (ngModelChange)="onDatosGestorChange()" placeholder="Documento">
              </div>
            </ng-container>
          </div>

          <!-- Tercera Fila: Dirección -->
          <div class="cvf-header-info-inline mt-1" style="display: flex; gap: 10px;" *ngIf="isCvfPoseedor()">
            <div class="info-item">
                  <span class="label-grey">Dirección Física Gestor:<span *ngIf="isGestorNoRegistradoPendiente()" class="oblig">*</span></span>
                  <span *ngIf="!shouldShowGestorAddressManualInput()" class="value-bold">{{ getDireccionFisicaGestor() }}</span>
                  <input *ngIf="shouldShowGestorAddressManualInput()" type="text" class="input-manual-gestor wide-address" [(ngModel)]="cvfData.direccionFisicaGestor" (ngModelChange)="onDatosGestorChange()" placeholder="Dirección">
            </div>
          </div>
          
                                         <!-- Cuarta Fila: Botón Guardar Datos Gestor Manual (solo Poseedor) -->
          <div class="cvf-header-info-inline mt-2 d-flex justify-content-start" *ngIf="isCvfPoseedor() && shouldShowGestorAddressManualInput() && isCvfPendiente() && canViewResource('PO-POSEEDOR')">
               <button class="btn btn-primary btn-sm" [disabled]="!datosGestorModificados" (click)="guardarDatosGestorManual()">Guardar</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="container-fluid content-page" *ngIf="cvfData">
  <div class="cvf-detail-page">

    <div class="row mt-1 ml-1 mb-4">
        <div class="col-12">
            <ng-container *ngIf="!isCvfPoseedor() && !canViewResource('PO-ENV-GEST') && isCvfPendiente()">
                <div *ngIf="cvfData?.combinaciones?.length === 1" class="header-instruction-text mb-3">
                    Complete los datos de la tabla desplegable
                </div>
                <div *ngIf="cvfData?.combinaciones?.length > 1" class="header-instruction-text mb-3">
                    Complete los datos de las tablas desplegables
                </div>
            </ng-container>

            <ng-container *ngIf="isCvfPoseedor() && canViewResource('PO-POSEEDOR') && !canViewResource('PO-ENV-GEST')">
                <div *ngIf="isCvfPendiente()" class="header-instruction-text mb-3">
                    Complete los datos CVF del gestor en la tabla desplegable.
                </div>
                <div *ngIf="isCvfPendienteFirmaOFirmado()" class="header-instruction-text mb-3">
                    Descargue el CVF para firmar.
                    <mat-icon (click)="descargarCertificadoCVF(cvfData)" class="ml-2 color-custom pointer-cursor" matTooltip="Descargar documento">download</mat-icon>
                </div>
                <div *ngIf="isCvfPendienteFirmaOFirmado()" class="header-instruction-text mb-3">
                    Adjunte el CVF firmado por el gestor en su correspondiente apartado de carga.
                    <mat-icon (click)="subirCVF(cvfData)" class="ml-2 color-custom pointer-cursor" matTooltip="Adjuntar documento">upload_file</mat-icon>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- Listado de combinaciones LER + Operación -->
    <div class="combinaciones-container mt-4">
      <div *ngFor="let combinacion of cvfData.combinaciones" class="combinacion-card mb-3">

        <!-- Fila principal de la combinación -->
        <div class="combinacion-header" [class.expanded]="combinacion.expanded">
          <div class="combinacion-info">
            <div class="ler-codigo">{{ combinacion.codigoLer }}</div>
            <div class="ler-descripcion">{{ combinacion.descripcionLer }}</div>
            <div class="d-flex flex-column ml-auto align-items-end">
              <div class="operacion-info d-flex align-items-center">
                <span *ngIf="isCombinationComplete(combinacion)" class="icon-complete-wrapper mr-2" title="Registro completo">
                  <i class="fas fa-check-circle"></i>
                </span>
                <span class="badge-operacion">{{ combinacion.operacionGestion}}</span>
                <span class="cantidad-total ml-2">{{ combinacion.cantidadTotal | number:'1.5-5':'es-ES' }} (t)</span>
              </div>
              <div class="operacion-info mt-1" *ngIf="combinacion.tipoOperacion === 'R' && combinacion.expanded">
                <span class="font-weight-bold ml-3" style="font-size: 0.9rem;">Cantidad Restante: </span>
                <span [class.text-danger]="calcularCantidadRestanteGlobal(combinacion) !== 0" 
                      [class.text-success]="calcularCantidadRestanteGlobal(combinacion) === 0"
                      style="font-size: 0.9rem; margin-left: 5px;">
                  {{ calcularCantidadRestanteGlobal(combinacion) | number:'1.5-5':'es-ES' }} (t)
                </span>
                <ng-container *ngIf="!isCvfPoseedor()">
                <span class="font-weight-bold ml-3" style="font-size: 0.9rem;">% Restante: </span>
                <span [class.text-danger]="calcularPorcentajeRestanteGlobal(combinacion) !== 0"
                      [class.text-success]="calcularPorcentajeRestanteGlobal(combinacion) === 0"
                      style="font-size: 0.9rem; margin-left: 5px;">
                  {{ calcularPorcentajeRestanteGlobal(combinacion) | number:'1.2-2':'es-ES' }} %
                </span>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="combinacion-actions">
            <button type="button" class="btn-icon-expand" (click)="toggleExpand(combinacion)"
              [attr.aria-label]="combinacion.expanded ? 'Colapsar' : 'Expandir'">
              <i class="fas" [class.fa-chevron-down]="!combinacion.expanded"
                [class.fa-chevron-up]="combinacion.expanded"></i>
            </button>
          </div>
        </div>

        <!-- Contenido desplegable -->
        <div class="combinacion-body" *ngIf="combinacion.expanded">

          <!-- TIPO D: Operaciones de Gestión de Eliminación -->
          <div *ngIf="combinacion.tipoOperacion === 'D'" class="tipo-d-container">
            <div class="section-title-small">
              <span class="titulo">Información sobre el Proceso de Gestión Final</span>
              <div class="tool-help" matTooltip="Indique la operación de gestión en destino final" data-placement="top">
                <span>?</span>
              </div>
            </div>

            <table class="table-cvf-detail">
              <thead>
                <tr>
                  <th class="header-super-title">Código LER y Descripción ENVALORA</th>
                  <th class="header-super-title">Operación de gestión</th>
                  <th class="header-super-title">Cantidad gestionada (t)</th>
                  <th class="header-super-title">Operación de Gestión en Destino Final<span class="oblig">*</span></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="cell-content">
                      <div class="ler-code">{{ combinacion.codigoLer }}</div>
                      <div class="ler-desc">{{ combinacion.descripcionLer }}</div>
                    </div>
                  </td>
                  <td>{{ combinacion.operacionGestion }}</td>
                  <td>
                    <input type="text" appFourDigitDecimalNumber class="input-small" 
                      [ngModel]="combinacion.cantidadTotal | number:'1.5-5':'es-ES'"
                      (change)="onCantidadTipoDChange(combinacion, $event)" 
                      [readonly]="true"
                      [disabled]="true">
                  </td>
                  <td>
                    <input type="text" class="input-small full-width"
                      [(ngModel)]="combinacion.operacionGestionDestino"
                      (ngModelChange)="onInputChange()"
                      [readonly]="!isEditable">
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- Botón Guardar para Tipo D -->
            <div class="d-flex justify-content-end mt-4" *ngIf="isEditable">
              <button type="button" class="btn btn-primary" (click)="guardarCombinacion(combinacion)"
                [disabled]="!cambiosSinGuardar || combinacionEnEdicion !== combinacion.id">
                Guardar
              </button>
              <span *ngIf="combinacion.guardado" class="badge-saved">
                <i class="fas fa-check-circle"></i> Guardado
              </span>
            </div>
          </div>

          <!-- TIPO R: Operaciones de Valorización -->
          <div *ngIf="combinacion.tipoOperacion === 'R'" class="tipo-r-container">

            <div class="section-header-with-help">
              <div class="section-title-small">Información sobre el Proceso de Gestión Final</div>
              <div *ngIf="!isCvfPoseedor()" class="tool-help"
                matTooltip="Complete todos los campos. Las cantidades y porcentajes deben cuadrar." data-placement="top">
                <span>?</span>
              </div>
              <div *ngIf="isCvfPoseedor()" class="tool-help" matTooltip="Complete todos los campos. Las cantidades deben cuadrar."
                data-placement="top">
                <span>?</span>
              </div>
            </div>

            <!-- VISTA POSEEDOR -->
            <ng-container *ngIf="isCvfPoseedor()">
                <div class="materiales-valorizados-section">
                    <div class="desglose-proceso-table" [ngStyle]="getPoseedorTableStyle()">
                        <table class="table-desglose">
                            <thead>
                                <tr>
                                    <th rowspan="3" class="header-super-title">Materiales principales</th>
                                    <th rowspan="3" class="header-super-title">Cantidad restante (t)</th>
                                    <th rowspan="3" class="header-super-title">Cantidad material (t)</th>
                                    <th rowspan="3" class="header-super-title">Mermas en instalaciones del gestor (t)</th>
                                    <th colspan="2" rowspan="3" class="header-super-title">Operaciones de destino final</th>
                                    <th colspan="4" class="header-super-title">Cantidad (t) por ubicación de la instalación de gestión</th>
                                    <th rowspan="3" class="header-super-title">Mermas destino final (t)</th>
                                </tr>
                                <tr>
                                    <th colspan="2" class="header-group">España</th>
                                    <th rowspan="2" class="header-single">Otros países UE</th>
                                    <th rowspan="2" class="header-single">Terceros Países</th>
                                </tr>
                                <tr>
                                    <th class="subheader">CCAA Origen</th>
                                    <th class="subheader">Otras CCAA</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let material of combinacion.materialesValorizados; let idx = index">
                                    <tr>
                                        <!-- Material Name -->
                                        <td class="material-name-cell">
                                            <div class="field-group">
                                                <span class="material-name">{{ material.descripcion }}</span>
                                                <span class="material-code">{{ material.codigoMaterial }}</span>
                                            </div>
                                        </td>

                                        <!-- Cantidad Restante -->
                                        <td>
                                            <span [class.text-danger]="calcularCantidadRestante(material) !== 0"
                                                  [class.text-success]="calcularCantidadRestante(material) === 0">
                                                  {{ calcularCantidadRestante(material) | number:'1.5-5':'es-ES' }}
                                            </span>
                                        </td>

                                        <!-- Cantidad Material -->
                                        <td class="input-cell">
                                            <input type="text" appFourDigitDecimalNumber class="input-small"
                                                [ngModel]="material.cantidad === 0 ? '' : (material.cantidad | number:'1.5-5':'es-ES')"
                                                placeholder="0,00000"
                                                (change)="onCantidadMaterialPoseedorChange(material, $event)"
                                                (keyup.enter)="onCantidadMaterialPoseedorChange(material, $event)"
                                                [readOnly]="!isEditable">
                                        </td>

                                        <!-- Mermas instalaciones gestor -->
                                        <td class="input-cell">
                                            <input type="text" appFourDigitDecimalNumber class="input-small"
                                                [ngModel]="material.mermas.cantidad === 0 ? '' : (material.mermas.cantidad | number:'1.5-5':'es-ES')"
                                                placeholder="0,00000"
                                                (change)="onCantidadChange(material, 'mermas', '', $event)"
                                                (keyup.enter)="onCantidadChange(material, 'mermas', '', $event)"
                                                [readOnly]="!isEditable">
                                        </td>

                                        <!-- Operaciones destino final (Code) -->
                                        <td class="input-cell" style="width: 280px !important; min-width: 250px !important;">
                                            <ng-select *ngIf="!isDestinoFinalReadOnly()"
                                                       #opSelect
                                                       [items]="operacionesDestinoFinal"
                                                       bindLabel="descripcion"
                                                       [(ngModel)]="material.operacionDestinoCode"
                                                       (change)="onOperacionDestinoChange(material, $event)"
                                                       placeholder="Seleccione..."
                                                       [clearable]="true"
                                                       [disabled]="!isEditable"
                                                       class="custom-ng-select"
                                                       [matTooltip]="opSelect.selectedItems[0] ? opSelect.selectedItems[0]['descripcion'] : ''"
                                                       [matTooltipShowDelay]="500">
                                                <ng-template ng-label-tmp let-item="item">
                                                    <div class="ng-value-label-truncate">
                                                        {{ item.descripcion }}
                                                    </div>
                                                </ng-template>
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div class="ng-option-label-truncate" [matTooltip]="item.descripcion" [matTooltipShowDelay]="500" matTooltipPosition="right">
                                                        {{ item.descripcion }}
                                                    </div>
                                                </ng-template>
                                            </ng-select>

                                            <input *ngIf="isDestinoFinalReadOnly()"
                                                   type="text"
                                                   class="form-control readonly-destino-input"
                                                   [value]="getOperacionDestinoDisplay(material)"
                                                   [readonly]="true"
                                                   [matTooltip]="getOperacionDestinoDisplay(material)"
                                                   [matTooltipShowDelay]="500">
                                        </td>

                                        <!-- Operaciones destino final (Description) -->
                                        <td class="input-cell">
                                             <input type="text" class="input-small"
                                                [(ngModel)]="material.operacionDestinoDesc"
                                                (ngModelChange)="onInputChange()"
                                                placeholder="Descripción"
                                                [readOnly]="!isEditable"
                                                [disabled]="!isTipoD(material)"
                                                [required]="isTipoD(material)">
                                        </td>

                                        <!-- España - CCAA Origen -->
                                        <td class="input-cell">
                                            <input type="text" appFourDigitDecimalNumber class="input-small"
                                                [ngModel]="material.reciclado.espanaCaOrigen.cantidad === 0 ? '' : (material.reciclado.espanaCaOrigen.cantidad | number:'1.5-5':'es-ES')"
                                                placeholder="0,00000"
                                                (change)="onCantidadChange(material, 'reciclado', 'espanaCaOrigen', $event)"
                                                (keyup.enter)="onCantidadChange(material, 'reciclado', 'espanaCaOrigen', $event)"
                                                [readOnly]="!isEditable">
                                        </td>

                                        <!-- España - Otras CCAA -->
                                        <td class="input-cell">
                                            <input type="text" appFourDigitDecimalNumber class="input-small"
                                                [ngModel]="material.reciclado.espanaOtraCa.cantidad === 0 ? '' : (material.reciclado.espanaOtraCa.cantidad | number:'1.5-5':'es-ES')"
                                                placeholder="0,00000"
                                                (change)="onCantidadChange(material, 'reciclado', 'espanaOtraCa', $event)"
                                                (keyup.enter)="onCantidadChange(material, 'reciclado', 'espanaOtraCa', $event)"
                                                [readOnly]="!isEditable">
                                        </td>

                                        <!-- Otros países UE -->
                                        <td class="input-cell">
                                            <input type="text" appFourDigitDecimalNumber class="input-small"
                                                [ngModel]="material.reciclado.eu.cantidad === 0 ? '' : (material.reciclado.eu.cantidad | number:'1.5-5':'es-ES')"
                                                placeholder="0,00000"
                                                (change)="onCantidadChange(material, 'reciclado', 'eu', $event)"
                                                (keyup.enter)="onCantidadChange(material, 'reciclado', 'eu', $event)"
                                                [readOnly]="!isEditable">
                                        </td>

                                        <!-- Terceros Países -->
                                        <td class="input-cell">
                                            <input type="text" appFourDigitDecimalNumber class="input-small"
                                                [ngModel]="material.reciclado.fueraUe.cantidad === 0 ? '' : (material.reciclado.fueraUe.cantidad | number:'1.5-5':'es-ES')"
                                                placeholder="0,00000"
                                                (change)="onCantidadChange(material, 'reciclado', 'fueraUe', $event)"
                                                (keyup.enter)="onCantidadChange(material, 'reciclado', 'fueraUe', $event)"
                                                [readOnly]="!isEditable">
                                        </td>

                                        <!-- Mermas destino final -->
                                        <td class="input-cell">
                                            <input type="text" appFourDigitDecimalNumber class="input-small"
                                                [ngModel]="material.mermasDestino === 0 ? '' : (material.mermasDestino | number:'1.5-5':'es-ES')"
                                                placeholder="0,00000"
                                                (change)="onCantidadMermasDestinoChange(material, $event)"
                                                (keyup.enter)="onCantidadMermasDestinoChange(material, $event)"
                                                [readOnly]="!isEditable">
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>

            <!-- SECCIÓN: Materiales Valorizados (EXISTING FOR GESTOR) -->
            <div class="materiales-valorizados-section" *ngIf="!isCvfPoseedor()">

              <!-- Tabla de desglose del proceso de gestión -->
              <div class="desglose-proceso-table">
                <table class="table-desglose">
                  <thead>
                    <tr>
                      <th colspan="3" rowspan="3" class="header-title">Materiales Valorizados</th>
                      <th colspan="11" class="header-super-title">Información sobre el proceso de gestión final</th>
                      <th rowspan="3" class="actions-header" *ngIf="isEditable"></th>
                    </tr>
                    <tr>
                      <th rowspan="2" class="header-single">% y Cantidad Restante</th>
                      <th colspan="4" class="header-group">Ámbito geográfico de las instalaciones donde se realizan las operaciones de reciclado</th>
                      <th colspan="4" class="header-group">Ámbito geográfico de las instalaciones donde se realizan las operaciones de reutilización de envases</th>
                      <th rowspan="2" class="header-single">Valorización Energética</th>
                      <th rowspan="2" class="header-single">Mermas en Destino Final</th>
                    </tr>
                    <tr>
                      <th class="subheader">CCAA Origen</th>
                      <th class="subheader">Otras CCAA</th>
                      <th class="subheader">EU</th>
                      <th class="subheader">Fuera UE</th>
                      <th class="subheader">CCAA Origen</th>
                      <th class="subheader">Otras CCAA</th>
                      <th class="subheader">EU</th>
                      <th class="subheader">Fuera UE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let material of combinacion.materialesValorizados; let idx = index">
                      <!-- Fila de Porcentaje -->
                      <tr>
                        <td rowspan="2" class="material-name-cell">
                          <div class="material-name-display">{{ material.descripcion }}</div>
                        </td>
                        <td class="row-label">%</td>
                        <!-- Total Porcentaje -->
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.porcentaje === 0 ? '' : (material.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeTotalChange(material, $event)"
                            (keyup.enter)="onPorcentajeTotalChange(material, $event)"
                            [readonly]="!isEditable">
                        </td>
                        <!-- Restante -->
                        <td>
                          <input type="text" class="input-small" 
                            [value]="(!material.porcentaje ? '' : (calcularPorcentajeRestante(material) | number:'1.2-2':'es-ES'))"
                            disabled 
                            [ngClass]="{
                              'text-danger': material.porcentaje && calcularPorcentajeRestante(material) !== 0,
                              'text-success': material.porcentaje && calcularPorcentajeRestante(material) === 0
                            }"
                            style="background-color: #e9ecef; font-weight: bold;">
                        </td>
                        <!-- Reciclado -->
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.reciclado.espanaCaOrigen.porcentaje === 0 ? '' : (material.reciclado.espanaCaOrigen.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeChange(material, 'reciclado', 'espanaCaOrigen', $event)" 
                            (keyup.enter)="onPorcentajeChange(material, 'reciclado', 'espanaCaOrigen', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.reciclado.espanaOtraCa.porcentaje === 0 ? '' : (material.reciclado.espanaOtraCa.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeChange(material, 'reciclado', 'espanaOtraCa', $event)" 
                            (keyup.enter)="onPorcentajeChange(material, 'reciclado', 'espanaOtraCa', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.reciclado.eu.porcentaje === 0 ? '' : (material.reciclado.eu.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeChange(material, 'reciclado', 'eu', $event)" 
                            (keyup.enter)="onPorcentajeChange(material, 'reciclado', 'eu', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.reciclado.fueraUe.porcentaje === 0 ? '' : (material.reciclado.fueraUe.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeChange(material, 'reciclado', 'fueraUe', $event)" 
                            (keyup.enter)="onPorcentajeChange(material, 'reciclado', 'fueraUe', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <!-- Preparación Reutilización -->
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.preparacionReutilizacion.espanaCaOrigen.porcentaje === 0 ? '' : (material.preparacionReutilizacion.espanaCaOrigen.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeChange(material, 'preparacionReutilizacion', 'espanaCaOrigen', $event)"
                            (keyup.enter)="onPorcentajeChange(material, 'preparacionReutilizacion', 'espanaCaOrigen', $event)"
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.preparacionReutilizacion.espanaOtraCa.porcentaje === 0 ? '' : (material.preparacionReutilizacion.espanaOtraCa.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeChange(material, 'preparacionReutilizacion', 'espanaOtraCa', $event)"
                            (keyup.enter)="onPorcentajeChange(material, 'preparacionReutilizacion', 'espanaOtraCa', $event)"
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.preparacionReutilizacion.eu.porcentaje === 0 ? '' : (material.preparacionReutilizacion.eu.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeChange(material, 'preparacionReutilizacion', 'eu', $event)"
                            (keyup.enter)="onPorcentajeChange(material, 'preparacionReutilizacion', 'eu', $event)"
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.preparacionReutilizacion.fueraUe.porcentaje === 0 ? '' : (material.preparacionReutilizacion.fueraUe.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeChange(material, 'preparacionReutilizacion', 'fueraUe', $event)"
                            (keyup.enter)="onPorcentajeChange(material, 'preparacionReutilizacion', 'fueraUe', $event)"
                            [readonly]="!isEditable">
                        </td>
                        <!-- Valorización Energética -->
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.valorizacionEnergetica.porcentaje === 0 ? '' : (material.valorizacionEnergetica.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeChange(material, 'valorizacionEnergetica', '', $event)" 
                            (keyup.enter)="onPorcentajeChange(material, 'valorizacionEnergetica', '', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <!-- Mermas -->
                        <td>
                          <input type="text" appTwoDigitDecimalNumber class="input-small"
                            [ngModel]="material.mermas.porcentaje === 0 ? '' : (material.mermas.porcentaje | number:'1.2-2':'es-ES')"
                            placeholder="0,00"
                            (change)="onPorcentajeChange(material, 'mermas', '', $event)" 
                            (keyup.enter)="onPorcentajeChange(material, 'mermas', '', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <td rowspan="2" class="actions-cell" *ngIf="isEditable">
                          <button type="button" class="btn btn-icon-only text-primary" *ngIf="material.esBorrable" (click)="eliminarMaterial(combinacion, idx)"
                            matTooltip="Eliminar material">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </tr>
                      <!-- Fila de Cantidad -->
                      <tr>
                        <td class="row-label">Cantidad (t)</td>
                        <!-- Total Cantidad -->
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small" 
                            [ngModel]="material.cantidad === 0 ? '' : (material.cantidad | number:'1.5-5':'es-ES')" 
                            placeholder="0,00000"
                            (change)="onCantidadTotalChange(material, $event)"
                            (keyup.enter)="onCantidadTotalChange(material, $event)"
                            [readonly]="!isEditable">
                        </td>
                        <!-- Restante -->
                        <td>
                          <input type="text" class="input-small"
                            [value]="(!material.cantidad ? '' : (calcularCantidadRestante(material) | number:'1.5-5':'es-ES'))"
                            disabled 
                            [ngClass]="{
                              'text-danger': material.cantidad && calcularCantidadRestante(material) !== 0,
                              'text-success': material.cantidad && calcularCantidadRestante(material) === 0
                            }"
                            style="background-color: #e9ecef; font-weight: bold;">
                        </td>
                        <!-- Reciclado -->
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small"
                            [ngModel]="material.reciclado.espanaCaOrigen.cantidad === 0 ? '' : (material.reciclado.espanaCaOrigen.cantidad | number:'1.5-5':'es-ES')"
                            placeholder="0,00000"
                            (change)="onCantidadChange(material, 'reciclado', 'espanaCaOrigen', $event)" 
                            (keyup.enter)="onCantidadChange(material, 'reciclado', 'espanaCaOrigen', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small"
                            [ngModel]="material.reciclado.espanaOtraCa.cantidad === 0 ? '' : (material.reciclado.espanaOtraCa.cantidad | number:'1.5-5':'es-ES')"
                            placeholder="0,00000"
                            (change)="onCantidadChange(material, 'reciclado', 'espanaOtraCa', $event)" 
                            (keyup.enter)="onCantidadChange(material, 'reciclado', 'espanaOtraCa', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small"
                            [ngModel]="material.reciclado.eu.cantidad === 0 ? '' : (material.reciclado.eu.cantidad | number:'1.5-5':'es-ES')"
                            placeholder="0,00000"
                            (change)="onCantidadChange(material, 'reciclado', 'eu', $event)" 
                            (keyup.enter)="onCantidadChange(material, 'reciclado', 'eu', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small"
                            [ngModel]="material.reciclado.fueraUe.cantidad === 0 ? '' : (material.reciclado.fueraUe.cantidad | number:'1.5-5':'es-ES')"
                            placeholder="0,00000"
                            (change)="onCantidadChange(material, 'reciclado', 'fueraUe', $event)" 
                            (keyup.enter)="onCantidadChange(material, 'reciclado', 'fueraUe', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <!-- Preparación Reutilización -->
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small"
                            [ngModel]="material.preparacionReutilizacion.espanaCaOrigen.cantidad === 0 ? '' : (material.preparacionReutilizacion.espanaCaOrigen.cantidad | number:'1.5-5':'es-ES')"
                            placeholder="0,00000"
                            (change)="onCantidadChange(material, 'preparacionReutilizacion', 'espanaCaOrigen', $event)"
                            (keyup.enter)="onCantidadChange(material, 'preparacionReutilizacion', 'espanaCaOrigen', $event)"
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small"
                            [ngModel]="material.preparacionReutilizacion.espanaOtraCa.cantidad === 0 ? '' : (material.preparacionReutilizacion.espanaOtraCa.cantidad | number:'1.5-5':'es-ES')"
                            placeholder="0,00000"
                            (change)="onCantidadChange(material, 'preparacionReutilizacion', 'espanaOtraCa', $event)"
                            (keyup.enter)="onCantidadChange(material, 'preparacionReutilizacion', 'espanaOtraCa', $event)"
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small"
                            [ngModel]="material.preparacionReutilizacion.eu.cantidad === 0 ? '' : (material.preparacionReutilizacion.eu.cantidad | number:'1.5-5':'es-ES')"
                            placeholder="0,00000"
                            (change)="onCantidadChange(material, 'preparacionReutilizacion', 'eu', $event)" 
                            (keyup.enter)="onCantidadChange(material, 'preparacionReutilizacion', 'eu', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small"
                            [ngModel]="material.preparacionReutilizacion.fueraUe.cantidad === 0 ? '' : (material.preparacionReutilizacion.fueraUe.cantidad | number:'1.5-5':'es-ES')"
                            placeholder="0,00000"
                            (change)="onCantidadChange(material, 'preparacionReutilizacion', 'fueraUe', $event)"
                             (keyup.enter)="onCantidadChange(material, 'preparacionReutilizacion', 'fueraUe', $event)"
                             [readonly]="!isEditable">
                        </td>
                        <!-- Valorización Energética -->
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small"
                            [ngModel]="material.valorizacionEnergetica.cantidad === 0 ? '' : (material.valorizacionEnergetica.cantidad | number:'1.5-5':'es-ES')"
                            placeholder="0,00000"
                            (change)="onCantidadChange(material, 'valorizacionEnergetica', '', $event)" 
                            (keyup.enter)="onCantidadChange(material, 'valorizacionEnergetica', '', $event)" 
                            [readonly]="!isEditable">
                        </td>
                        <!-- Mermas -->
                        <td>
                          <input type="text" appFourDigitDecimalNumber class="input-small"
                            [ngModel]="material.mermas.cantidad === 0 ? '' : (material.mermas.cantidad | number:'1.5-5':'es-ES')"
                            placeholder="0,00000"
                            (change)="onCantidadChange(material, 'mermas', '', $event)" 
                            (keyup.enter)="onCantidadChange(material, 'mermas', '', $event)" 
                            [readonly]="!isEditable">
                        </td>
                      </tr>
                    </ng-container>
                    </tbody>
                  </table>
                </div>

              <div class="d-flex justify-content-start mt-2" *ngIf="isEditable">
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="onAddMaterial(combinacion)">
                  Añadir nuevo material
                </button>
              </div>
            </div>

            <!-- SECCIÓN: Mermas en Propias Instalaciones -->
            <div class="mermas-section mt-4" *ngIf="!isCvfPoseedor()">

              <table class="table-mermas-grid">
                <thead *ngIf="!canViewResource('PO-ENV-GEST') || (combinacion.mermas && combinacion.mermas.length > 0)">
                  <tr>
                    <th colspan="3" *ngIf="canViewResource('PO-GESTOR') && isCvfPendiente()">Añada las mermas generadas en sus propias instalaciones</th>
                    <th colspan="3" *ngIf="!isCvfPendiente() || canViewResource('PO-ENV-GEST')">Mermas en las propias instalaciones</th>
                  </tr>
                </thead>
                <tbody *ngIf="combinacion.mermas && combinacion.mermas.length > 0">
                  <ng-container *ngFor="let merma of combinacion.mermas; let i = index">
                    <tr>
                      <td rowspan="2" class="operation-cell">
                        {{ merma.operacionGestion?.codigo || merma.operacionGestionDTO?.codigo || merma.operacionGestion || 'R12' }}
                        <button *ngIf="isEditable" type="button" class="btn btn-icon-only text-primary" 
                        (click)="eliminarMerma(combinacion, i)" title="Eliminar merma">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                      <td class="label-cell">%</td>
                      <td class="input-cell">
                        <input type="text" appTwoDigitDecimalNumber class="input-small"
                          [ngModel]="merma.porcentaje === 0 ? '' : (merma.porcentaje | number:'1.2-2':'es-ES')"
                          placeholder="0,00"
                          (change)="onMermaPorcentajeChange(merma, combinacion, $event)" 
                          (keyup.enter)="onMermaPorcentajeChange(merma, combinacion, $event)" 
                          [readonly]="!isEditable">
                      </td>
                    </tr>
                    <tr>
                      <td class="label-cell">Cantidad (t)</td>
                      <td class="input-cell">
                        <input type="text" appFourDigitDecimalNumber class="input-small"
                          [ngModel]="merma.cantidad === 0 ? '' : (merma.cantidad | number:'1.5-5':'es-ES')"
                          placeholder="0,00000"
                          (change)="onMermaCantidadChange(merma, combinacion, $event)" 
                          (keyup.enter)="onMermaCantidadChange(merma, combinacion, $event)" 
                          [readonly]="!isEditable">
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>

              <div class="d-flex justify-content-start mt-2" *ngIf="isEditable">
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="onAddMerma(combinacion)">
                  Añadir nueva merma
                </button>
              </div>

            </div>

            <!-- Botón Guardar para Tipo R -->
            <div class="d-flex justify-content-end mt-4" *ngIf="isEditable">
              <button type="button" class="btn btn-primary" (click)="guardarCombinacion(combinacion)"
                [disabled]="!cambiosSinGuardar || combinacionEnEdicion !== combinacion.id">
                Guardar
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Sección Inferior: Checkbox y Botones -->
    <div class="d-flex align-items-center mt-4 mb-4">

      <!-- Checkbox a la izquierda -->
      <div class="confirmation-section">
        <mat-checkbox [(ngModel)]="confirmacionFinal" [disabled]="!canConfirm()">
          <span class="confirmation-section-stile">"Confirmo la veracidad y la exactitud de los datos reflejados y cumplimentados en el Certificado de Valorización Final."</span> <span class="oblig"> *</span>
        </mat-checkbox>
      </div>

      <!-- Espaciador para empujar botones a la derecha -->
      <div style="flex: 1;"></div>

      <!-- Botones a la derecha -->
      <div class="d-flex align-items-center">
        <button type="button" class="btn btn-outline-primary" style="margin-right: 15px;" (click)="cerrar()" aria-label="Volver al listado">
          CERRAR
        </button>
        <button *ngIf="(cvfData?.estado?.id === 7 && isCvfPoseedor()) || (!isCvfPoseedor() && cvfData?.estado?.id === 1)" [disabled]="!isCvfComplete() || !confirmacionFinal" type="button" class="btn btn-primary" style="margin-left: 15px;" (click)="ejecutarFinalizarCVF()"
          aria-label="Finalizar">
          <i class="fas fa-check"></i> Finalizar
        </button>
        <button *ngIf="isCvfPoseedor() && isEditable && isCvfPendiente()" [disabled]="!isCvfComplete() || !confirmacionFinal" type="button" class="btn btn-primary" style="margin-left: 15px;" (click)="finalizarCVF()"
          aria-label="Finalizar">
          <i class="fas fa-check"></i> Guardar CVF
        </button>
      </div>

    </div>

  </div>
</div>